export const convertLayoutTags = (tags: any): string[] => {
  if (!Array.isArray(tags)) {
    return [];
  }

  return tags.map((elem: any) => elem.toString()).filter((elem: any) => !!elem);
};

export default convertLayoutTags;
